<template>
  <div
    class="row details mb-3 mb-md-0"
    :class="{ 'internet_auction': auctionsCatalog.auctionType === 'internet' }"
    v-if="auctionsCatalog && auctionsCatalog.auctionHouse"
  >
    <div
      v-if="auctionsCatalog.auctionHouse.id"
      class="art-house-logo ml-3"
    >
      <img
        :src="auctionsCatalog.auctionHouse.logoThumbUrl"
      />
    </div>
    <div class="col-12 col-sm-auto auction_house-details">
      <div
        v-if="auctionsCatalog.auctionType === 'internet'"
        class="internet-catalog__date-range"
      >
        <span class="icon icon-calendar" />
        {{ dateRange }}
      </div>
      <h2 v-html="auctionHouseHeader" />
      <h4
        v-if="auctionsCatalog.auctionHouse.name"
        class="headings--h4"
      >
        {{ auctionsCatalog.name }}
      </h4>
      <div
        v-if="auctionsCatalog.auctionType !== 'internet'"
        class="details__info"
      >
        <p>
          <span class="icon icon-calendar" />
          <span class="headings--h3 details__inline-spacer mr-2">
            {{ I18n.l("time.formats.full_date", auctionsCatalog.startDate) }}
          </span>
          <span class="headings--h4 details_inline-spacer">
            {{ I18n.l("time.formats.weekday", auctionsCatalog.startDate) }}
          </span>
        </p>
        <p>
          <span class="icon icon-time" />
          <span class="headings--h3">{{ startTime }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  export default {
    name: 'AuctionHouseCard',
    computed: {
      ...mapGetters(['auctionsCatalog']),
      startTime() {
        return this.auctionsCatalog.startDate.substring(11, 16);
      },
      auctionHouseHeader() {
        if (this.auctionsCatalog.auctionHouse.name) {
          return this.auctionsCatalog.auctionHouse.name;
        }
        return this.auctionsCatalog.name;
      },
      dateRange() {
        return `${this.manageDate(this.auctionsCatalog.startDate, 'DD.MM')} - ${this.manageDate(this.auctionsCatalog.endDate, 'DD.MM.YYYY')}`;
      },
    },
    methods: {
      manageDate(date, format) {
        return moment(date).format(format);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/auction_house_card.vue?38b2f4d4